module.exports = __webpack_public_path__ + "img/square-kanban-light.b6a7ff5d.svg";